import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

/**
 * Price Calculator Tour Steps:
 * 0: body (Welcome)
 * 1: #mapitShip-btn - MapitShip sidebar button
 * 2: #price-calculator-btn - Price calculator in sidebar
 * 3: #price-calculator-card - Price calculator form
 * 4: #view-prices-btn - View prices button
 * 5: body (Completion)
 */
export const priceCalculatorTourSteps = (isMobile, isScrollableDrawer) => [
    {
        target: "body",
        title: <Stack justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" />
            {i18n.t("tutorial.priceCalculatorTour.title")}
        </Stack>,
        content: i18n.t("tutorial.priceCalculatorTour.step1"),
        placement: "center",
    },
    {
        target: "#mapitShip-btn",
        content: i18n.t("tutorial.priceCalculatorTour.step2"),
        placement: "left",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },
    },
    {
        target: "#price-calculator-btn",
        content: i18n.t("tutorial.priceCalculatorTour.step3"),
        placement: "bottom",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 445 : 450 : 0,
            },
        },
    },
    {
        target: "#price-calculator-card",
        content: i18n.t("tutorial.priceCalculatorTour.step4"),
        placement: "top",
    },
    {
        target: "#view-prices-btn",
        content: i18n.t("tutorial.priceCalculatorTour.step5"),
        placement: "top",
    },
    {
        target: "body",
        title: <Box display="flex" justifyContent="center" alignItems="center">
            <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" />
        </Box>,
        content: i18n.t("tutorial.priceCalculatorTour.end"),
        placement: "center",
    },
];
